import { usePage } from "@/components/page/PageContext";
import { PlayDetail } from "@/components/playlist/PlayDetail";
import { ChevronLeft, MinusIcon } from "lucide-react";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

export function PlayDetailPage() {
  const { playId } = useParams<{ playId: string }>();
  const { setTitles } = usePage();
  const navigate = useNavigate();

  useEffect(() => {
    setTitles(["Play Details"]);
  }, [setTitles]);

  const handleBackClick = () => {
    navigate(-1);
  };

  if (!playId) {
    return (
      <div className="p-6 text-center">
        <p className="text-red-500">Play ID not found</p>
      </div>
    );
  }

  return (
    <div className="container mx-auto p-6">
      {/* Breadcrumb Navigation */}
      <div className="mb-6">
        <div className="flex items-center mt-2 text-sm text-muted-foreground">
          <button
            onClick={handleBackClick}
            className="flex items-center text-muted-foreground hover:text-foreground p-0 h-auto font-normal"
          >
            <ChevronLeft className="h-3 w-3 mr-2" />
            <span className="text-sm">All Pain Points</span>
          </button>
          <MinusIcon className="h-3 w-3 mx-2 rotate-180" />
          <span className="text-foreground">Play Details</span>
        </div>
      </div>

      <PlayDetail playId={parseInt(playId)} />
    </div>
  );
}
